export default "__VITE_ASSET__Bmumfiqb__"